import React from 'react';
import View from "./core/views";

function App() {
  return (
    <div className="App">
      <View></View>
    </div>
  );
}

export default App;